import { render, staticRenderFns } from "./CardsProjects.vue?vue&type=template&id=dbba1424&scoped=true&"
import script from "./CardsProjects.vue?vue&type=script&lang=js&"
export * from "./CardsProjects.vue?vue&type=script&lang=js&"
import style0 from "./CardsProjects.vue?vue&type=style&index=0&id=dbba1424&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbba1424",
  null
  
)

export default component.exports